export enum FinancialType {
  Asset = 'ASSET',
  Liability = 'LIABILITY',
}

export type FinancialInfo = {
  financialType: FinancialType;
  financialSubtype: string;
  amount: number;
  currency: string;
};

export type FetchedFinancialInfo = FinancialInfo & {
  id: string;
  clientId: number;
  operationId: string;
  createdAt: string;
  updatedAt: string;
};

export type FinanceInfoResponse = FetchedFinancialInfo[];
